module.exports = __webpack_public_path__ + "static/media/group.94e17a53.jpg";